import React from "react";

export default function TotalsBox({
  subtotal,
  tax,
  total,
  paid,
  balance,
  money,
}) {
  const hasPaid = paid !== undefined && paid !== null;
  const hasBalance = balance !== undefined && balance !== null;

  return (
    <div className="jt-document-section jt-doc-totals-box">
      <div className="jt-doc-totals-row">
        <span>Subtotal</span>
        <strong>{money(subtotal)}</strong>
      </div>

      <div className="jt-doc-totals-row">
        <span>Tax</span>
        <strong>{money(tax)}</strong>
      </div>

      {hasPaid && (
        <div className="jt-doc-totals-row">
          <span>Paid</span>
          <strong>{money(paid)}</strong>
        </div>
      )}

      <div className="jt-doc-totals-divider" />

      <div className="jt-doc-grand-total">
        <span>{hasBalance ? "Balance" : "Total"}</span>
        <strong>{money(hasBalance ? balance : total)}</strong>
      </div>
    </div>
  );
}
